export const buildPath = (location, base) => `${base || ''}${location}`
